import Text from 'components/Text/Text';
import React, { useContext, useEffect, useRef } from 'react';
import { IGetDishesShort, IGetDishesShortArgs } from 'types';
import { Select } from 'antd';
import { useFetchData } from 'hooks/useFetchData';
import { getDishesShortByCustomerId } from 'backend/dishes';
import SelectDropdownReloader from 'components/SelectDropdownReloader/SelectDropdownReloader';
import { useTranslation } from 'react-i18next';
import {
	ChangeComboGroupPositionContext,
	IChangeComboGroupPositionContext,
} from '../../../../../changeComboGroupPositionState/changeComboGroupPositionContext';
import style from './DishSelect.module.scss';

const { Option } = Select;

const DishSelect: React.FC = () => {
	const { setIDDish, IDSelectedCustomer, IDSelectedDish } = useContext<IChangeComboGroupPositionContext>(
		ChangeComboGroupPositionContext,
	);
	const parentNodeRef = useRef<null | HTMLSpanElement>(null);
	const { response, loading, refetch, responseError } = useFetchData<IGetDishesShort, IGetDishesShortArgs>(
		IDSelectedCustomer ? getDishesShortByCustomerId : null,
		{ customerId: IDSelectedCustomer || '', isCombo: true },
	);
	const { t } = useTranslation('listing');

	useEffect(() => {
		refetch();
	}, [IDSelectedCustomer]);

	return (
		<div className={style.container}>
			<Text translationNameSpace="listing" translationKey="dishLabel" theme="neutralLight" size="xs" />
			<span ref={parentNodeRef} style={{ position: 'relative' }} />
			<Select
				className={style.select}
				onChange={setIDDish}
				value={IDSelectedDish}
				loading={loading}
				disabled={!IDSelectedCustomer || loading}
				notFoundContent={responseError ? <SelectDropdownReloader onReload={refetch} /> : undefined}
				showSearch={true}
				filterOption={(inputValue, option) =>
					option?.children ? String(option.children).toLowerCase().includes(inputValue.toLowerCase()) : false
				}
				listItemHeight={response?.data.dishes.length}
				allowClear={true}
				getPopupContainer={() => parentNodeRef.current as HTMLSpanElement}
				placeholder={t('selectPlaceholder')}>
				{response?.data.dishes.length ? (
					<>
						<Option className={style.disabledItem} value="empty" disabled={true}>
							<Text
								translationNameSpace="listing"
								translationKey="selectAnyItemPlaceholder"
								asFragment={true}
							/>
						</Option>
						{response.data.dishes.map((el) => (
							<Option className={style.listItem} value={el.id} key={el.id}>
								{el.name}
							</Option>
						))}
					</>
				) : null}
			</Select>
		</div>
	);
};

export default DishSelect;
